var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaEnkeltRedWebbshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.163,
    height: 27.36,
    viewBox: "0 0 40.163 27.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(-169.882 -457.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M3.734,1.44A1.257,1.257,0,0,1,4.69,1H15.428a1.257,1.257,0,0,1,.956.44l3.28,3.827a1.886,1.886,0,0,1,.454,1.227v.321a2.986,2.986,0,0,1-5.344,1.833,2.987,2.987,0,0,1-4.715,0,2.987,2.987,0,0,1-4.715,0A2.986,2.986,0,0,1,0,6.815V6.495A1.886,1.886,0,0,1,.454,5.268L3.736,1.439ZM5.972,6.815a1.729,1.729,0,0,0,3.458,0,.629.629,0,0,1,1.257,0,1.729,1.729,0,1,0,3.458,0,.629.629,0,0,1,1.257,0,1.729,1.729,0,0,0,3.458,0V6.495a.629.629,0,0,0-.151-.409L15.428,2.257H4.69L1.408,6.086a.629.629,0,0,0-.151.409v.321a1.729,1.729,0,0,0,3.458,0,.629.629,0,0,1,1.257,0ZM1.886,10.43a.629.629,0,0,1,.629.629V18.6H3.772V12.316a1.257,1.257,0,0,1,1.257-1.257H8.8a1.257,1.257,0,0,1,1.257,1.257V18.6H17.6V11.059a.629.629,0,0,1,1.257,0V18.6h.629a.629.629,0,0,1,0,1.257H.629a.629.629,0,1,1,0-1.257h.629V11.059A.629.629,0,0,1,1.886,10.43ZM5.029,18.6H8.8V12.316H5.029Zm6.287-6.287a1.257,1.257,0,0,1,1.257-1.257h2.515a1.257,1.257,0,0,1,1.257,1.257v3.772a1.257,1.257,0,0,1-1.257,1.257H12.574a1.257,1.257,0,0,1-1.257-1.257Zm3.772,0H12.574v3.772h2.515Z",
    transform: "translate(169.882 456.97)",
    fill: "#ff1e56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user",
    "data-name": "Icon feather-user",
    transform: "translate(184.409 460.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M24.885,28.332a.75.75,0,0,1-.75-.75v-.361a3.976,3.976,0,0,0-3.971-3.971H10.721A3.971,3.971,0,0,0,6.75,27.221v.361a.75.75,0,1,1-1.5,0v-.361a5.471,5.471,0,0,1,5.471-5.471h9.443a5.478,5.478,0,0,1,5.471,5.471v.361A.75.75,0,0,1,24.885,28.332Z",
    transform: "translate(0 -3.836)",
    fill: "#ff1e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M16.721,3.75h0A5.471,5.471,0,1,1,11.25,9.221,5.478,5.478,0,0,1,16.721,3.75Zm0,9.443a3.971,3.971,0,1,0,0-7.943h0a3.971,3.971,0,0,0,0,7.943Z",
    transform: "translate(-1.279 1)",
    fill: "#ff1e56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaEnkeltRedWebbshop);
export default __webpack_public_path__ + "static/media/sa-enkelt-red-webbshop.22edf5348ca95d374781e9cf6e9992a5.svg";
export { ForwardRef as ReactComponent };